import React, { useCallback, useEffect, useReducer } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { useCookies } from "react-cookie";
import { getList } from "../../../controller/api/__loto__/result";
import { calculatePage } from "../../../helper/helper";
import { Spinner } from "@themesberg/react-bootstrap";

export const Context = React.createContext(null);

let next7Days = new Date()

next7Days.setDate(next7Days.getDate() + 7)

const initialData = {
  filter: {
    from: new Date(),
    to: next7Days,
    channelId: '',
    page: 0
  },
  data: {
    list: [],
    total: 0,
    classicUser: [],
    totalPage: 0
  },
  isLoaded: false,
  isLoading: false,
  filterPressCount: 0,
  exportPressCount: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        },
        isLoaded: true
      }
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: Boolean(action.payload)
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        }
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['lottmekong'])

  const getAllFunc = useCallback(async () => {
    dispatch({
      type: 'SET_LOADING',
      payload: true
    })

    try {
      const response = await getList(cookies.lottmekong, {
        from: state.filter.from,
        to: state.filter.to,
      }, state.filter.page)

      if (response) {
        dispatch({
          type: 'UPDATE_DATA',
          payload: {
            list: response.data,
            total: response.total,
            classicUser: response.classicUser,
            totalPage: calculatePage(response.total)
          }
        })
      }
    } finally {
      dispatch({
        type: 'SET_LOADING',
        payload: false
      })
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.page])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc, state.filterPressCount, state.filter.page])

  useEffect(() => {
    document.title = 'Kỳ quay'
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>
      <div className="py-4">
        <FilterForm />

        <div className="mt-4 position-relative">
          {!state.isLoaded ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <>
              <Table />
              {state.isLoading && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                  style={{
                    background: "rgba(255, 255, 255, 0.6)",
                    backdropFilter: "blur(1px)",
                  }}
                >
                  <Spinner animation="border" variant="primary" />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Context.Provider>
  );
};
